import React from 'react';
export function CustomerInfo({
  customer,
  setCustomer
}) {
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setCustomer(prev => ({
      ...prev,
      [name]: value
    }));
  };
  return <div className="mb-8" data-id="element-36">
      <h2 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-37">
        Customer Information
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-38">
        <div data-id="element-39">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-40">
            Name <span className="text-red-500" data-id="element-41">*</span>
          </label>
          <input type="text" name="name" value={customer.name} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" required data-id="element-42" />
        </div>
        <div data-id="element-43">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-44">
            Email <span className="text-red-500" data-id="element-45">*</span>
          </label>
          <input type="email" name="email" value={customer.email} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" required data-id="element-46" />
        </div>
        <div data-id="element-47">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-48">
            Phone <span className="text-red-500" data-id="element-49">*</span>
          </label>
          <input type="tel" name="phone" value={customer.phone} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" required data-id="element-50" />
        </div>
        <div data-id="element-51">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-52">
            State <span className="text-red-500" data-id="element-53">*</span>
          </label>
          <input type="text" name="state" value={customer.state} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" required data-id="element-54" />
        </div>
        <div className="md:col-span-2" data-id="element-55">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-56">
            Shipping Address (Optional)
          </label>
          <input type="text" name="address" value={customer.address} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" data-id="element-57" />
        </div>
        <div data-id="element-58">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-59">
            City (Optional)
          </label>
          <input type="text" name="city" value={customer.city} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" data-id="element-60" />
        </div>
        <div data-id="element-61">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-62">
            ZIP Code (Optional)
          </label>
          <input type="text" name="zip" value={customer.zip} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" data-id="element-63" />
        </div>
      </div>
    </div>;
}